import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./store/index";
import { Provider } from "react-redux";
import "react-notifications-component/dist/theme.css";

import "./i18n"; // Add this line

// Find the root element in your HTML
const container = document.getElementById("root");

// Create a root
const root = createRoot(container);

// Initial render: Render the app component to the root
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
